export default __webpack_public_path__ + "static/media/EthLogo.4988b46c.svg";